import DOMPurify from "dompurify";

export type BadgeVariant = "alert" | "warning" | "info";

/** Sanitizes an unknown value as a string using DOMPurify. Returns "" for non-strings. */
export function sanitize(str: unknown): string {
  return typeof str === "string" ? DOMPurify.sanitize(str) : "";
}

/** Maps a notification priority string to a badge variant. */
export function getVariant(priority?: string): BadgeVariant {
  const p = priority?.toLowerCase();
  if (p === "high" || p === "critical") return "alert";
  if (p === "medium") return "warning";
  return "info";
}
